import { render, staticRenderFns } from "./EdenAttachmentsDragAndDrop.vue?vue&type=template&id=65270cc7&scoped=true"
import script from "./EdenAttachmentsDragAndDrop.vue?vue&type=script&lang=js"
export * from "./EdenAttachmentsDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./EdenAttachmentsDragAndDrop.vue?vue&type=style&index=0&id=65270cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65270cc7",
  null
  
)

export default component.exports